import CommentRepositoryInterface, {
  ChatCommentInterface,
  CommentInterface,
  MessageCommentInterface, ReplyCommentInterface, TicketCommentInterface,
} from '@/services/QA/comment/interfaces';
import { AxiosInstance } from 'axios';

export default class CommentRepository implements CommentRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async addChatComment(
    chatId: string,
    commentData: Partial<CommentInterface>,
    notifyUsers: boolean = false,
  ): Promise<ChatCommentInterface> {
    const res = await this.axios.post(`/qa-controller/chat/${chatId}/comments`, { commentData, notifyUsers });

    return res.data;
  }

  public async addMessageComment(
    chatId: string,
    messageId: number,
    commentData: Partial<CommentInterface>,
    notifyUsers?: boolean,
  ): Promise<MessageCommentInterface> {
    const res = await this.axios.post(`/qa-controller/chat/${chatId}/messages/${messageId}/comments`, {
      commentData,
      notifyUsers,
    });

    return res.data;
  }

  public async deleteComment(commentId: number): Promise<void> {
    await this.axios.delete(`/qa-controller/comments/${commentId}`);
  }

  public async editComment(commentId: number, content: string, notifyUsers: boolean): Promise<void> {
    await this.axios.patch(`/qa-controller/comments/${commentId}`, { content, notifyUsers });
  }

  public async addTicketComment(
    ticketId: number,
    commentData: Partial<CommentInterface>,
    notifyUsers?: boolean,
  ): Promise<TicketCommentInterface> {
    const res = await this.axios.post(
      `/qa-controller/ticket/${ticketId}/comments`,
      {
        commentData,
        notifyUsers,
      });

    return res.data;
  }

  public async addReplyComment(
    ticketId: number,
    replyId: number,
    commentData: Partial<CommentInterface>,
    notifyUsers?: boolean,
  ): Promise<ReplyCommentInterface> {
    const res = await this.axios.post(
      `/qa-controller/ticket/${ticketId}/replies/${replyId}/comments`,
      {
        commentData,
        notifyUsers,
      });

    return res.data;
  }
}
